import CardEvent from './CardEvent.js';

const initCardEvent = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="card-event"]'));

  elements.forEach((element) => {
    new CardEvent(element);
  });
};

export default initCardEvent;
